var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 2C5.58172 2 2 5.58172 2 10C2 14.4183 5.58172 18 10 18C14.4183 18 18 14.4183 18 10C18 5.58172 14.4183 2 10 2ZM0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#18181A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 12C9.44771 12 9 11.5523 9 11V10C9 9.44771 9.44772 9 10 9C10.5523 9 11 9.44771 11 10V11C11 11.5523 10.5523 12 10 12Z",
    fill: "#18181A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 14.5C8.5 13.6716 9.17157 13 10 13C10.8284 13 11.5 13.6716 11.5 14.5C11.5 15.3284 10.8284 16 10 16C9.17157 16 8.5 15.3284 8.5 14.5Z",
    fill: "#18181A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3899 5.81137C9.4329 5.7658 8.63039 6.3004 8.48639 7.1644C8.3956 7.70917 7.88037 8.07719 7.3356 7.9864C6.79083 7.8956 6.42281 7.38037 6.51361 6.8356C6.86961 4.69961 8.8171 3.73421 10.4851 3.81363C11.3395 3.85432 12.2176 4.16099 12.8937 4.79278C13.5866 5.44027 14 6.36777 14 7.5C14 8.79131 13.4919 9.74892 12.6172 10.3321C11.8141 10.8675 10.8295 11 10 11C9.44772 11 9 10.5523 9 10C9 9.44771 9.44772 9 10 9C10.6705 9 11.1859 8.88252 11.5078 8.66795C11.7581 8.50109 12 8.2087 12 7.5C12 6.88224 11.7884 6.49723 11.5282 6.2541C11.2512 5.99526 10.848 5.83318 10.3899 5.81137Z",
    fill: "#18181A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircle);
export default __webpack_public_path__ + "static/media/question-circle.c1f508c0117583e9b98a0b99d60a7240.svg";
export { ForwardRef as ReactComponent };